import React, { useState } from 'react';
import { useNavigate, Link as RouterLink } from 'react-router-dom';
import { Box, Button, TextField, Typography, Alert, Link } from '@mui/material';
import { API_BASE_URL } from './api';
import AppFooter, { APP_FOOTER_RESERVE_PX } from './components/AppFooter';

function Register() {
  const [email, setEmail] = useState('');
  const [name, setName] = useState('');
  const [password, setPassword] = useState('');
  const [passwordConfirmation, setPasswordConfirmation] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const res = await fetch(`${API_BASE_URL}register`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          email,
          name,
          password,
          password_confirmation: passwordConfirmation,
        }),
      });
      const data = await res.json().catch(() => ({}));
      if (!res.ok) {
        const msg =
          data.message ||
          (data.errors && Object.values(data.errors).flat().join(' ')) ||
          'Registration failed.';
        throw new Error(typeof msg === 'string' ? msg : 'Registration failed.');
      }
      if (data.token) {
        localStorage.setItem('token', data.token);
        localStorage.setItem('user', JSON.stringify(data.user));
      }
      navigate('/login');
    } catch (err) {
      setError(err.message || 'Registration failed.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        background: 'linear-gradient(160deg, #0f172a 0%, #1e1b4b 100%)',
        paddingBottom: `${APP_FOOTER_RESERVE_PX}px`,
        boxSizing: 'border-box',
      }}
    >
      <Box
        sx={{
          flex: '1 1 auto',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          p: 2,
          minHeight: 0,
        }}
      >
      <Box
        component="form"
        onSubmit={handleSubmit}
        sx={{
          width: '100%',
          maxWidth: 400,
          p: 3,
          borderRadius: 3,
          bgcolor: 'rgba(15, 23, 42, 0.85)',
          border: '1px solid rgba(148, 163, 184, 0.15)',
        }}
      >
        <Typography variant="h5" sx={{ mb: 2, color: '#f8fafc', fontWeight: 700 }}>
          Register
        </Typography>
        <Typography variant="body2" sx={{ mb: 2, color: '#94a3b8' }}>
          Your account will have the &quot;User&quot; role (driver portal access). Ask an administrator for admin
          access.
        </Typography>
        {error && (
          <Alert severity="error" sx={{ mb: 2 }}>
            {error}
          </Alert>
        )}
        <TextField
          fullWidth
          label="Email"
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
          margin="normal"
          InputLabelProps={{ sx: { color: '#94a3b8' } }}
          sx={{ input: { color: '#f8fafc' } }}
        />
        <TextField
          fullWidth
          label="Name"
          value={name}
          onChange={(e) => setName(e.target.value)}
          required
          margin="normal"
          InputLabelProps={{ sx: { color: '#94a3b8' } }}
          sx={{ input: { color: '#f8fafc' } }}
        />
        <TextField
          fullWidth
          label="Password"
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
          margin="normal"
          InputLabelProps={{ sx: { color: '#94a3b8' } }}
          sx={{ input: { color: '#f8fafc' } }}
        />
        <TextField
          fullWidth
          label="Confirm password"
          type="password"
          value={passwordConfirmation}
          onChange={(e) => setPasswordConfirmation(e.target.value)}
          required
          margin="normal"
          InputLabelProps={{ sx: { color: '#94a3b8' } }}
          sx={{ input: { color: '#f8fafc' } }}
        />
        <Button
          type="submit"
          fullWidth
          variant="contained"
          disabled={loading}
          sx={{ mt: 2, py: 1.25, fontWeight: 700 }}
        >
          {loading ? 'Submitting…' : 'Create account'}
        </Button>
        <Typography variant="body2" sx={{ mt: 2, textAlign: 'center', color: '#94a3b8' }}>
          <Link component={RouterLink} to="/login" color="inherit" underline="hover">
            Log in
          </Link>
        </Typography>
      </Box>
      </Box>
      <AppFooter variant="dark" />
    </Box>
  );
}

export default Register;
